var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('video',{ref:"mediaItem",class:_vm.classes,attrs:{"playsinline":"","src":_vm.url,"poster":_vm.posterUrl,"height":`${_vm.$vuetify.breakpoint.height - _vm.videoBorderSize * 2}px`,"width":`${((_vm.$vuetify.breakpoint.height - _vm.videoBorderSize * 2) * 16) / 9}px`},on:{"ended":_vm.videoEndedEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }